module.exports = __webpack_public_path__ + "static/media/dragIcon.62cd9b58.svg";